import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import Hero from '../components/Hero';
// import Logo from '../components/Logo';
import Post from '../components/Post';
// import herovideo from "../images/videos/loop-nino.mp4"
// import herovideo from '../images/videos/loop-nino.mp4';
import herowithoutlogo from '../images/videos/intro-lovesong.mp4';
import logo from '../images/jpg/logo-the-cure.png';
import {
	StyledPosts,
	StyledSection,
	StyledPostBlockTitle,
	StyledGuide,
	StyledVideos
} from '../components/Post/style.css';
// import Image from '../components/Image';
// import VideoPlayer from '../components/VideoPlayer';
// import PostIntro from '../components/StaticPosts/PostIntro';
// import PostCierre from '../components/StaticPosts/PostCierre';
import PostCreditos from '../components/StaticPosts/PostCreditos';
import PostBajada from '../components/StaticPosts/PostBajada';
import Share from '../components/Sharer';

import SpotifyPlayerHolder from '../components/SpotifyPlayerHolder';
// import LottieObj from '../components/LottieObj';
// import ProgressBar from 'react-scroll-progress-bar';

class IndexPage extends React.Component {
	render() {
		return (
			<Layout>
				{/* <ProgressBar height="6" bgcolor="#F00" duration="0.2" /> */}
				<Seo title="" />
				<Hero videosrc={herowithoutlogo}>
					<img src={logo} width="90%" />
				</Hero>
				<PostBajada />
				<SpotifyPlayerHolder />

				{/* <LottieObj /> */}
				<Share
					socialConfig={{
						twitterHandle: '@cultolt',
						config: {
							url: `https://especiales.latercera.com/culto-the-cure/`,
							title: `The Cure: treinta años de Disintegration - Culto`,
							via: 'cultolt'
						}
					}}
				/>
				<StyledPosts>
					{this.props.data.allWordpressPost.edges.map(({ node }) => <Post key={node.id} post={node} />)}
				</StyledPosts>

				{/* <PostCierre /> */}

				<PostCreditos />
			</Layout>
		);
	}
}

export const pageQuery = graphql`
	query getByTag($tagslug: String = "especial-the-cure") {
		allWordpressPost(
			filter: { tags: { elemMatch: { slug: { eq: $tagslug } } } }
			sort: { fields: date, order: DESC }
		) {
			edges {
				node {
					id
					...PostContent
				}
			}
		}
	}
`;

export default IndexPage;
